import { createContext } from 'react';

const preventionContext = createContext();

export default preventionContext;
